function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  y: 0.007,
  width: 512,
  height: 511.989
});

var _ref3 = /*#__PURE__*/React.createElement("g", null);

var _ref4 = /*#__PURE__*/React.createElement("g", null);

var _ref5 = /*#__PURE__*/React.createElement("g", null);

var _ref6 = /*#__PURE__*/React.createElement("g", null);

var _ref7 = /*#__PURE__*/React.createElement("g", null);

var _ref8 = /*#__PURE__*/React.createElement("g", null);

var _ref9 = /*#__PURE__*/React.createElement("g", null);

var _ref10 = /*#__PURE__*/React.createElement("g", null);

var _ref11 = /*#__PURE__*/React.createElement("g", null);

var _ref12 = /*#__PURE__*/React.createElement("g", null);

var _ref13 = /*#__PURE__*/React.createElement("g", null);

var _ref14 = /*#__PURE__*/React.createElement("g", null);

var _ref15 = /*#__PURE__*/React.createElement("g", null);

var _ref16 = /*#__PURE__*/React.createElement("g", null);

var _ref17 = /*#__PURE__*/React.createElement("g", null);

function Svg225Libya(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Capa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, /*#__PURE__*/React.createElement("rect", {
    y: 0.001,
    style: {
      fill: "#D80027"
    },
    width: 512,
    height: 170.663
  }), /*#__PURE__*/React.createElement("rect", {
    y: 341.336,
    style: {
      fill: "#496E2D"
    },
    width: 512,
    height: 170.663
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F0F0F0"
    },
    points: "290.723,228.72 302.961,245.586 322.783,239.16 310.525,256.011 322.763,272.877    302.947,266.426 290.689,283.277 290.701,262.439 270.887,255.988 290.709,249.56  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F0F0F0"
    },
    d: "M257.318,298.157c-23.283,0-42.158-18.875-42.158-42.158s18.875-42.158,42.158-42.158   c7.26,0,14.09,1.835,20.054,5.067c-9.355-9.148-22.15-14.796-36.269-14.796c-28.655,0-51.886,23.231-51.886,51.887   s23.23,51.886,51.887,51.886c14.119,0,26.913-5.648,36.269-14.796C271.409,296.321,264.578,298.157,257.318,298.157z"
  })), _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg225Libya);
export default "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iaXNvLTg4NTktMSI/Pgo8IS0tIEdlbmVyYXRvcjogQWRvYmUgSWxsdXN0cmF0b3IgMTkuMC4wLCBTVkcgRXhwb3J0IFBsdWctSW4gLiBTVkcgVmVyc2lvbjogNi4wMCBCdWlsZCAwKSAgLS0+CjxzdmcgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgdmVyc2lvbj0iMS4xIiBpZD0iQ2FwYV8xIiB4PSIwcHgiIHk9IjBweCIgdmlld0JveD0iMCAwIDUxMiA1MTIiIHN0eWxlPSJlbmFibGUtYmFja2dyb3VuZDpuZXcgMCAwIDUxMiA1MTI7IiB4bWw6c3BhY2U9InByZXNlcnZlIj4KPHJlY3QgeT0iMC4wMDciIHdpZHRoPSI1MTIiIGhlaWdodD0iNTExLjk4OSIvPgo8cmVjdCB5PSIwLjAwMSIgc3R5bGU9ImZpbGw6I0Q4MDAyNzsiIHdpZHRoPSI1MTIiIGhlaWdodD0iMTcwLjY2MyIvPgo8cmVjdCB5PSIzNDEuMzM2IiBzdHlsZT0iZmlsbDojNDk2RTJEOyIgd2lkdGg9IjUxMiIgaGVpZ2h0PSIxNzAuNjYzIi8+CjxnPgoJPHBvbHlnb24gc3R5bGU9ImZpbGw6I0YwRjBGMDsiIHBvaW50cz0iMjkwLjcyMywyMjguNzIgMzAyLjk2MSwyNDUuNTg2IDMyMi43ODMsMjM5LjE2IDMxMC41MjUsMjU2LjAxMSAzMjIuNzYzLDI3Mi44NzcgICAgMzAyLjk0NywyNjYuNDI2IDI5MC42ODksMjgzLjI3NyAyOTAuNzAxLDI2Mi40MzkgMjcwLjg4NywyNTUuOTg4IDI5MC43MDksMjQ5LjU2ICAiLz4KCTxwYXRoIHN0eWxlPSJmaWxsOiNGMEYwRjA7IiBkPSJNMjU3LjMxOCwyOTguMTU3Yy0yMy4yODMsMC00Mi4xNTgtMTguODc1LTQyLjE1OC00Mi4xNThzMTguODc1LTQyLjE1OCw0Mi4xNTgtNDIuMTU4ICAgYzcuMjYsMCwxNC4wOSwxLjgzNSwyMC4wNTQsNS4wNjdjLTkuMzU1LTkuMTQ4LTIyLjE1LTE0Ljc5Ni0zNi4yNjktMTQuNzk2Yy0yOC42NTUsMC01MS44ODYsMjMuMjMxLTUxLjg4Niw1MS44ODcgICBzMjMuMjMsNTEuODg2LDUxLjg4Nyw1MS44ODZjMTQuMTE5LDAsMjYuOTEzLTUuNjQ4LDM2LjI2OS0xNC43OTZDMjcxLjQwOSwyOTYuMzIxLDI2NC41NzgsMjk4LjE1NywyNTcuMzE4LDI5OC4xNTd6Ii8+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPC9zdmc+Cg==";
export { ForwardRef as ReactComponent };